import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Tag, Clock } from 'lucide-react';
import './BlogPage.css';

export const BlogPostCard = ({ post }) => {
    return (
        <Link to={`/blog/${post.slug}`} className="blog-post-card-link">
            <div className="blog-post-card blog-page-card">
                <img src={post.image} alt={post.title} className="blog-post-image"/>
                <div className="blog-content">
                     <div className="blog-meta">
                        <span className="blog-category"><Tag size={14}/> {post.category}</span>
                        <span className="blog-date"><Clock size={14}/> {post.date}</span>
                     </div>
                    <h4>{post.title}</h4>
                    <p>{post.excerpt}</p>
                    <span className="read-more-link">
                        Czytaj dalej <ArrowRight size={18} />
                    </span>
                </div>
            </div>
        </Link>
    );
};

// WAŻNE: W tym pliku nie ma default export! Tylko nazwany export const BlogPostCard.